module.exports = "<div class=\"progress-outer\">\n  <div class=\"progress-inner\" [style.width]=\"progress + '%'\">\n  \t<p>{{progress}}%</p>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/progress-bar/progress-bar.html
// module id = 306
// module chunks = 0 1